import React, { useEffect, useState } from "react";
import GrayCard from "components/gray-card";
import TextInput from "components/inputs/text-input";
import Typography from "components/typography";
import { Colors } from "utils/colors";
import styled from "styled-components";
import { Languages } from "constants/languages";
import Dropdown from "components/inputs/dropdown";
import { ITrackDetails } from "types/musicData";
import TextDropdown from "components/inputs/text-dropdown";

interface IProps {
  setTrackDetails: (object: ITrackDetails) => void;
  data?: ITrackDetails;
}
const TrackDetails = ({ setTrackDetails, data }: IProps) => {
  const [trackTitle, setTrackTitle] = useState(data?.title);
  const [recordLabel, setRecordLabel] = useState(data?.recorLabel);
  const [mixVersion, setMixVersion] = useState(data?.mixVersion);
  const [recordingYear, setRecordingYear] = useState(
    data?.recordingYear || new Date().getFullYear().toString()
  );
  const [releaseLanguage, setReleaseLanguage] = useState(data?.language);

  const trackVersionList = [
    "Remix",
    "Live",
    "Remastered",
    "Acoustic Version",
    "Demo",
    "Instrumental Version",
    "Karaoke Version",
    "Radio Edit",
    "Extended Version",
    "Acapella",
    "Freestyle"
  ];

  useEffect(() => {
    setTrackDetails({
      title: trackTitle,
      recorLabel: recordLabel,
      mixVersion: mixVersion,
      recordingYear: recordingYear,
      language: releaseLanguage
    });
  }, [trackTitle, releaseLanguage, recordLabel, recordingYear, mixVersion]);
  return (
    <GrayCard title="Track Details">
      <InputItem>
        <TextInput
          label="Track Title"
          value={trackTitle}
          onChange={(e) => setTrackTitle(e.target.value)}
        />
      </InputItem>
      {/* <InputItem>
        <TextInput
          label="Record Label"
          disabled
          value={recordLabel}
          onChange={(e) => setRecordLabel(e.target.value)}
        />
      </InputItem> */}
      <InputItem>
        <Typography mb="0.4" weight="medium" color={Colors.grey400}>
          Track Mix Version
        </Typography>
        <Dropdown
          placeholder="Select Track Version (Optional)"
          chosenItem={mixVersion}
          selectItem={(value) => setMixVersion(value)}
          items={trackVersionList}
        />
      </InputItem>
      <InputItem>
        <TextInput
          type="number"
          label="Recording Year"
          placeholder="2025"
          value={recordingYear}
          onChange={(e) => setRecordingYear(e.target.value)}
        />
      </InputItem>
      <InputItem>
        <Typography mb="0.4" weight="medium" color={Colors.grey400}>
          Release Language
        </Typography>
        <TextDropdown
          value={releaseLanguage || ""}
          placeholder="what language is your release title in?"
          items={Languages}
          chosenItem={releaseLanguage}
          selectItem={(value) => setReleaseLanguage(value)}
        />
      </InputItem>
    </GrayCard>
  );
};

export default TrackDetails;

const InputItem = styled.div`
  margin-bottom: 2.4rem;
`;
